export const ShipmentTypes = [ 'domestic', 'international' ] as const;
export type ShipmentTypes = typeof ShipmentTypes[number];
